import CustomStore from 'devextreme/data/custom_store';
import { app } from '../main';
import serializeFilter from './serialize-filter';

export default url => {
  const store = new CustomStore({
    key: 'id',
    paginate: false,
    load: async loadOptions => {
      const params = {};

      if (loadOptions.sort) {
        params.ordering = loadOptions.sort.map(x => (x.desc ? '-' : '') + x.selector)
          .join(',');
      }
      if (loadOptions.take) {
        params.skip = loadOptions.skip;
        params.take = loadOptions.take;
      }
      if (loadOptions.filter) {
        params.filters = serializeFilter(loadOptions.filter, loadOptions.dataField);
      }
      if (loadOptions.searchValue) {
        params.search = loadOptions.searchValue;
      }

      const results =  await app.$http.get(url, { params });
      return {
        data: results,
        totalCount: results.length,
      };
    },
  });
  return store;
};
